/** Form validation messages. */
const dictionary = {
  "en": {
    "invalidCredentials": "Invalid email address or password",
    "invalidEmailFormat": "Email address must include . and @",
    "emailRequired": "Please enter your email",
    "nameLettersOnly": "Name should only contain letters",
    "emailAlreadyExists": "Email address already exist",
    "companyNameRequired": "Please provide company name",
    "cannotBeEmpty": "Cannot be empty",
    "invalidEmail": "Invalid email address",
    "fieldRequired": "This field is required.",
    "validEmail": "Please enter a valid email address.",
    "validNumber": "Please enter a valid number.",
    "atLeastOneItem": "Please provide at least one item.",
    "selectValidOption": "Please select a valid option.",
    "passwordsMustMatch": "Passwords must match",
    "termsRequired": "Please agree to our Terms of Service and Privacy policy.",
    "companyNameRegistered": "Company name already registered",
    "validPhone": "Please enter a valid phone number",
    "selectIndustry": "Please select relevant industry for your company",
    "selectEmployeeCount": "Please select number of employees in your company",
    "phoneExists": "Phone number already exists.",
    "selectDepartment": "Please select department",
    "selectJobDepartment": "Select Job Department",
    "enterTeamTitle": "Please enter team title",
    "enterTeamName": "Please enter team name",
    "selectBusinessType": "Select business type",
    "selectCompanySize": "Please select company size",
    "assignCandidateToTeam": "Please assign candidate to the team",
    "fillAllFields": "Please fill all fields",
    "passwordMismatch": "Confirm password does not match new password",
    "passwordMustBeSame": "Password must be same",
    "invalidCurrentPassword": "Invalid current password",
    "pleaseSelectGroup": "Please select group",
    "codeEmpty": "Code cannot be empty",
    "incorrectCode": "Incorrect code. Please try again.",
    "positionTitleRequired": "Please enter position title",
    "targetProfileRequired": "Please select target profile"
  },
  "de": {
    "invalidCredentials": "Ungültige E-Mail-Adresse oder ungültiges Passwort",
    "invalidEmailFormat": "Die E-Mail-Adresse muss . und @ enthalten",
    "emailRequired": "Bitte geben Sie Ihre E-Mail-Adresse ein",
    "nameLettersOnly": "Der Name darf nur Buchstaben enthalten",
    "emailAlreadyExists": "Diese E-Mail-Adresse existiert bereits",
    "companyNameRequired": "Bitte geben Sie den Unternehmensnamen an",
    "cannotBeEmpty": "Darf nicht leer sein",
    "invalidEmail": "Ungültige E-Mail-Adresse",
    "fieldRequired": "Dieses Feld ist erforderlich.",
    "validEmail": "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
    "validNumber": "Bitte geben Sie eine gültige Zahl ein.",
    "atLeastOneItem": "Bitte geben Sie mindestens einen Eintrag an.",
    "selectValidOption": "Bitte wählen Sie eine gültige Option.",
    "passwordsMustMatch": "Die Passwörter müssen übereinstimmen",
    "termsRequired": "Bitte stimmen Sie unseren Nutzungsbedingungen und der Datenschutzerklärung zu.",
    "companyNameRegistered": "Unternehmensname bereits registriert",
    "validPhone": "Bitte geben Sie eine gültige Telefonnummer ein",
    "selectIndustry": "Bitte wählen Sie die passende Branche für Ihr Unternehmen",
    "selectEmployeeCount": "Bitte wählen Sie die Anzahl der Mitarbeitenden in Ihrem Unternehmen",
    "phoneExists": "Telefonnummer existiert bereits.",
    "selectDepartment": "Bitte wählen Sie eine Abteilung",
    "selectJobDepartment": "Abteilung wählen",
    "enterTeamTitle": "Bitte geben Sie den Teamtitel ein",
    "enterTeamName": "Bitte geben Sie den Teamnamen ein",
    "selectBusinessType": "Branche wählen",
    "selectCompanySize": "Bitte wählen Sie die Unternehmensgröße",
    "assignCandidateToTeam": "Bitte weisen Sie die Person einem Team zu",
    "fillAllFields": "Bitte füllen Sie alle Felder aus",
    "passwordMismatch": "Die Passwortbestätigung stimmt nicht mit dem neuen Passwort überein",
    "passwordMustBeSame": "Das Passwort muss übereinstimmen",
    "invalidCurrentPassword": "Ungültiges aktuelles Passwort",
    "pleaseSelectGroup": "Bitte wählen Sie eine Gruppe",
    "codeEmpty": "Der Code darf nicht leer sein",
    "incorrectCode": "Falscher Code. Bitte versuchen Sie es erneut.",
    "targetProfileRequired": "Bitte wählen Sie ein Zielprofil",
    "positionTitleRequired": "Bitte geben Sie die Positionsbezeichnung ein"
  },
  "fi": {
    "invalidCredentials": "Virheellinen sähköpostiosoite tai salasana",
    "invalidEmailFormat": "Sähköpostiosoitteessa on oltava merkit . ja @",
    "emailRequired": "Anna sähköpostiosoitteesi",
    "nameLettersOnly": "Nimessä saa olla vain kirjaimia",
    "emailAlreadyExists": "Sähköpostiosoite on jo käytössä",
    "companyNameRequired": "Anna yrityksen nimi",
    "cannotBeEmpty": "Ei voi olla tyhjä",
    "invalidEmail": "Virheellinen sähköpostiosoite",
    "fieldRequired": "Tämä kenttä on pakollinen.",
    "validEmail": "Anna kelvollinen sähköpostiosoite.",
    "validNumber": "Anna kelvollinen luku.",
    "atLeastOneItem": "Anna vähintään yksi kohde.",
    "selectValidOption": "Valitse kelvollinen vaihtoehto.",
    "passwordsMustMatch": "Salasanojen on oltava samat",
    "termsRequired": "Hyväksy käyttöehtomme ja tietosuojakäytäntömme.",
    "companyNameRegistered": "Yrityksen nimi on jo rekisteröity",
    "validPhone": "Anna kelvollinen puhelinnumero",
    "selectIndustry": "Valitse yrityksellesi sopiva toimiala",
    "selectEmployeeCount": "Valitse yrityksesi työntekijöiden määrä",
    "phoneExists": "Puhelinnumero on jo käytössä.",
    "selectDepartment": "Valitse osasto",
    "selectJobDepartment": "Valitse osasto",
    "enterTeamTitle": "Anna tiimin nimi",
    "enterTeamName": "Anna tiimin nimi",
    "selectBusinessType": "Valitse liiketoimintatyyppi",
    "selectCompanySize": "Valitse yrityksen koko",
    "assignCandidateToTeam": "Lisää hakija tiimiin",
    "fillAllFields": "Täytä kaikki kentät",
    "passwordMismatch": "Vahvistettu salasana ei vastaa uutta salasanaa",
    "passwordMustBeSame": "Salasanojen on oltava samat",
    "invalidCurrentPassword": "Virheellinen nykyinen salasana",
    "pleaseSelectGroup": "Valitse ryhmä",
    "codeEmpty": "Koodi ei voi olla tyhjä",
    "incorrectCode": "Virheellinen koodi. Yritä uudelleen.",
    "positionTitleRequired": "Anna tehtävänimike",
    "targetProfileRequired": "Valitse kohdeprofiili"
  }
};

export default dictionary;
